import { Admin } from '@models/Admin'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { ADMIN_URL } from '@utils/urls'

const fetchAdmins = (params: TableParams) =>
  SBAPI.FetchPaginated<Admin[]>(ADMIN_URL, params)

const fetchAdminById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Admin>(`${ADMIN_URL}/${id}`, params)

const createAdmin = (role: Admin) => SBAPI.Post(ADMIN_URL, role)

const updateAdmin = (role: Admin) => SBAPI.Put(`${ADMIN_URL}/${role.id}`, role)

const deleteAdmin = (role: Admin) => SBAPI.Delete(`${ADMIN_URL}/${role.id}`)

export { createAdmin, deleteAdmin, fetchAdminById, fetchAdmins, updateAdmin }
